import sal from 'sal.js';

export default function() {
  sal();
}
